import BusinessIcon from "@mui/icons-material/Business";
import CabinIcon from "@mui/icons-material/Cabin";
import RepeatIcon from "@mui/icons-material/Repeat";
import SchoolIcon from "@mui/icons-material/School";
import Timeline from "@mui/lab/Timeline";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import Typography from "@mui/material/Typography";
import * as React from "react";

export default function About() {
  return (
    <Timeline position="alternate">
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0", color: "#ebeae8" }}
          align="right"
          variant="body2"
        >
          01-June-2022 -- Present
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="secondary">
            <BusinessIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span" sx={{ color: "#28b7fa" }}>
            Medlink HealthCare Ltd
          </Typography>
          <Typography color="secondary">Software Engineer</Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0", color: "#ebeae8" }}
          align="right"
          variant="body2"
        >
          01-September-2021 -- 30-April-2022
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="secondary">
            <BusinessIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span" sx={{ color: "#28b7fa" }}>
            Desoft Technology Limited
          </Typography>
          <Typography color="secondary">Junior Software Developer</Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0", color: "#ebeae8" }}
          variant="body2"
        >
          10-July-2021 -- 5-September-2021
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="primary">
            <CabinIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span" sx={{ color: "#28b7fa" }}>
            Programming Hero End Game
          </Typography>
          <Typography color="secondary">Front-end Developer</Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0", color: "#ebeae8" }}
          variant="body2"
        >
          01-August-2017 -- 30-June-2022
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="secondary">
            <SchoolIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span" sx={{ color: "#28b7fa" }}>
            Diploma In Engineering At Dhaka Polytechnic Institute
          </Typography>
          <Typography color="secondary">Compter Technology</Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent
          sx={{ m: "auto 0", color: "#ebeae8" }}
          variant="body2"
        >
          10-June-2019 -- Present
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="primary">
            <RepeatIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography variant="h6" component="span" sx={{ color: "#28b7fa" }}>
            Competitive Programmer
          </Typography>
          <Typography sx={{ color: "#ff8103" }}>
            life is good at programming
          </Typography>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
}
